const config = {
    // In local development, connect to localhost:5000; in production, use same-origin relative root or current origin
    apiUrl: (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'))
      ? 'http://localhost:5000'
      : (typeof window !== 'undefined' && window.location.origin ? window.location.origin : '')
};

export default config;
